import app from './../index';

export default class RechnungController {

	constructor ($routeParams, $uibModal) {
		this.dateOptions = {
			formatYear: 'yy',
			startingDay: 1
		};

		this.rechnungId = $routeParams.id;
		this.modal = $uibModal;
		this.serviceBase = app.serviceBase;

		this.refresh();
	}

	refresh() {
		this.rechnung = app.api.rechnungen.get({ id: this.rechnungId });
	}

	rechnungStornieren () {
		this.rechnung.$stornieren();
	}

	bezahlen () {

		var zahlungsInfo = {
			Datum: new Date(),
			Skonto: 0.0
		};

		var rechnung = this.rechnung;

		var modalInstance = this.modal.open({
			templateUrl: 'app/rechnungen/dialogRechnungBezahlen.html',
			size: 'md',
			resolve: {
				zahlungsInfo: function () {
					return zahlungsInfo;
				}
			},
			controller: function ($scope, $modalInstance, zahlungsInfo) {

				$scope.zahlungsInfo = zahlungsInfo;

				$scope.ok = function () {
					$modalInstance.close();
				};

				$scope.cancel = function() {
					$modalInstance.dismiss();
				};
			}
		});

		modalInstance.result
			.then( () => {
				rechnung.$bezahlen(zahlungsInfo);
				window.toastr.info("Rechnung wurde bezahlt");
				this.refresh();
			});
	}
}

RechnungController.$inject = ['$routeParams', '$uibModal'];



/** WEBPACK FOOTER **
 ** ./public/app/rechnungen/RechnungController.js
 **/